import React, { useContext, useState, useEffect, useCallback } from 'react';
import { DispositionModule } from '../../DispositionModule/index';
import { modifyData, setAnalyticsData } from '../StartOrderUtilities/startOderUtils';
import START_ORDER_CONSTANTS from '../Constants/startOrderConstants';
import SelectContentDispositionItems from 'organisms/SelectContentDisposition';
import {
  dispositionChangeAnalytics,
  modifyDataDisposition,
} from 'organisms/SelectContentDisposition/SelectContentDispositionUtilities/SelectContentDispositionUtil';
import {
  isEmptyEvery,
  isEmptyObject,
  openClearCartModal,
  clearAllAndHardReload,
  isSupportedTenantCode,
  getValueOrDefaultObject,
} from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import {
  DISPOSITION_LIST,
  LOCAL_STORAGE_KEYS,
  SESSION_STORAGE_KEYS,
  ROUTE_URL,
  DISPOSITION_KEYS,
  DISPOSITION_TYPES,
} from 'common/constants/SharedConstants';
import { useLocation } from 'react-router-dom';
import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';
import { useSelector, useDispatch } from 'react-redux';
import { FORM, STORES } from 'organisms/SearchStore/AU/Config/searchStore.config';
import { resetStores } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import { displayNotifyMessage } from 'organisms/SearchStore/SearchStoreUtilities/AutoDetectionUtils';
import { localisationStartAnalytics, setLocalisationFinishAnalyticsData } from 'common/utilities/analyticsUtils';
import { getDeliveryAddressSearchTypes } from 'organisms/DeliveryAddressSearchForm/DeliveryAddressSearchFormUtilities/DeliveryAddressSearchFormUtils';

export const StartOrderComponent = props => {
  const { userParams, contentData, showHeader = true, hideTimeslot, showCateringDisposition } = props;
  const {
    DISPOSITION_DATA,
    SCHEDULE_ORDER_DATA,
    DISPOSITION_METHOD,
    SHOW_CLEAR_CART_ALERT,
    SEARCH_ORDER_DATA,
    CLEAR_CART_CONFIRM_CANCEL_MODAL,
    clearCartExposedFlag,
    searchStoreAlertTitle,
    CURRENT_STORE_INFO,
    SET_FIND_A_KFC_VIEW,
    ORDER_SUMMARY_MODAL_CLOSE,
    SCHEDULE_ORDER_CLICKED,
    SHOW_SCHEDULE_DISPOSITION,
  } = START_ORDER_CONSTANTS;
  const { segmentedHomePageData = [] } = contentData;
  const { headline = [], supportedDispositions = [] } = segmentedHomePageData;
  const startOrderContentData = (props.contentData && modifyData(headline, supportedDispositions)) || {};
  const dispositionContentData =
    (props.contentData?.contentDispositionData &&
      isEmptyObject(props.contentData.contentDispositionData) &&
      modifyDataDisposition(props.contentData.contentDispositionData)) ||
    {};
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext) || {};
  const disposition = localStorage.getItem(LOCAL_STORAGE_KEYS.SERVICE_TYPE);
  const activeDisposition = disposition?.toUpperCase();
  const { enableAddressLocalisation = false } = useSelector(data => getValueOrDefaultObject(data.tenantReducer));
  const isDelivery = userOrderState?.dispositionStateData?.dispositionType === DISPOSITION_TYPES.DELIVERY.toLowerCase();
  const goToDeliveryAddressSearchForm = enableAddressLocalisation && isDelivery;
  const { cartData = {} } = useSelector(data => data.cartReducer);
  const [showBlackStripeContent, setShowBlackStripeContent] = useState(showHeader);
  const deliverySearchTypes = getDeliveryAddressSearchTypes();
  const [deliverySearchType, setDeliverySearchType] = useState(deliverySearchTypes[0]);
  const location = useLocation();
  const dispatch = useDispatch();
  const isHeaderTrackOrderEnabled = useCallback(() => {
    return (
      (userParams.loggedIn &&
        (location?.pathname === ROUTE_URL.HOME ||
          location?.pathname === ROUTE_URL.HOME_PAGE ||
          location?.pathname === ROUTE_URL.ACCOUNT ||
          location?.pathname === ROUTE_URL.ACTIVE_ORDERS)) ||
      (sessionStorage.getItem(SESSION_STORAGE_KEYS.PICKUP_ORDER_CANCELLED) &&
        (location?.pathname === ROUTE_URL.HOME || location?.pathname === ROUTE_URL.HOME_PAGE))
    );
  }, [location?.pathname, userParams.loggedIn]);

  useEffect(() => {
    if (!isHeaderTrackOrderEnabled()) {
      setShowBlackStripeContent(true);
      sessionStorage.removeItem(SESSION_STORAGE_KEYS.PICKUP_ORDER_CANCELLED);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userParams.localized, isHeaderTrackOrderEnabled()]);

  // reset the delivery address search type when disposition selection is shown.
  // this covers both the back button and the close button.
  useEffect(() => {
    if (userOrderState?.dispositionStateData?.showDisposition) {
      setDeliverySearchType(deliverySearchTypes[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userOrderState?.dispositionStateData?.showDisposition]);

  /**
   * Method to open disposition module
   */
  const onStartOrderClick = () => {
    setAnalyticsData();
    userOrderStateDispatch({ type: SET_FIND_A_KFC_VIEW, value: { findAKFC: false } });
    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
    userOrderStateDispatch({ type: ORDER_SUMMARY_MODAL_CLOSE, orderSummaryModalClose: true });

    localStorage.setItem(LOCAL_STORAGE_KEYS.RETAIN_ADDRESS, '');
    if (showCateringDisposition) {
      localisationStartAnalytics();
      userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: true, configSearchScreen: STORES } });
      localStorage.setItem(LOCAL_STORAGE_KEYS.CONFIG_SEARCH_SCREEN, FORM);
      userOrderStateDispatch({
        type: DISPOSITION_METHOD,
        value: { dispositionType: DISPOSITION_KEYS.CATERING },
      });
      dispatch(resetStores());
    } else {
      userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
    }
  };

  /**
   * Method to open open date time module
   */
  const scheduleOrderButtonClickHandler = (e, selectedStoreInfo) => {
    e.preventDefault();
    e.stopPropagation();
    userOrderStateDispatch({ type: SET_FIND_A_KFC_VIEW, value: { findAKFC: false } });
    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_DATA,
      value: { showScheduleOrderCatering: true, selectedStoreInfo: selectedStoreInfo, changeFlow: true },
    });
    userOrderStateDispatch({
      type: CURRENT_STORE_INFO,
      value: selectedStoreInfo,
    });
    userOrderStateDispatch({ type: SHOW_SCHEDULE_DISPOSITION, value: { showSheduleDisposition: false } });
    userOrderStateDispatch({ type: SCHEDULE_ORDER_CLICKED, value: { scheduleModeClicked: false } });
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.SET_ORDER_NOW,
      value: { showOrderNow: false },
    });
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.SET_SCHEDULE_ORDER_REORDER,
      value: { showScheduleOrderReorder: false },
    });
  };

  const dispositionChange = (event, type) => {
    let selectedDispositionType = '';
    event.stopPropagation();
    event.preventDefault();
    dispositionChangeAnalytics(type);
    selectedDispositionType = type.trim();
    if (DISPOSITION_LIST?.includes(selectedDispositionType.toUpperCase())) {
      userOrderStateDispatch({
        type: DISPOSITION_METHOD,
        value: { dispositionType: selectedDispositionType },
      });
      if (cartData?.foodLines?.length > 0) {
        //open clear cart alert
        let modalOpenObj = { flag: clearCartExposedFlag, onConfirm: searchStoreAlertTitle };
        openClearCartModal(
          userOrderStateDispatch,
          modalOpenObj,
          SHOW_CLEAR_CART_ALERT,
          CLEAR_CART_CONFIRM_CANCEL_MODAL,
        );
      } else {
        userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: true } });
      }
    }
  };
  const startOrder = (
    <LazyLoaderWrapper
      importPath='START_ORDER_ITEMS'
      contentData={startOrderContentData}
      clickHandler={onStartOrderClick}
    />
  );

  const headerTrackOrder = () => {
    if (isHeaderTrackOrderEnabled()) {
      return (
        <LazyLoaderWrapper
          {...props}
          testId='HeaderTrackOrderComponent'
          importPath='APP_HEADER_ORDER_TRACKER_COMP'
          setShowBlackStripeContent={setShowBlackStripeContent}
          isHeaderTrackOrderEnabled={isHeaderTrackOrderEnabled}
        ></LazyLoaderWrapper>
      );
    }
  };

  const contentDisposition = (
    <SelectContentDispositionItems
      contentData={dispositionContentData}
      clickHandler={scheduleOrderButtonClickHandler}
      selectedInfo={userOrderState}
      hideTimeslot={hideTimeslot}
      showBlackStripeContent={showBlackStripeContent}
      headerTrackOrder={headerTrackOrder}
      activeDisposition={activeDisposition}
      dispositionChange={dispositionChange}
    />
  );

  const blackStripeContent = () => {
    let res = startOrder;
    if (isHeaderTrackOrderEnabled()) {
      res = showBlackStripeContent ? (
        <div>
          {startOrder} {headerTrackOrder()}
        </div>
      ) : (
        headerTrackOrder()
      );
    }
    if (!isSupportedTenantCode() && isEmptyObject(dispositionContentData) && userParams.localized) {
      res = contentDisposition;
    } else if (userParams.localized) {
      const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
        ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW))
        : userOrderState.dispositionNew;
      if (dispositionNew && isEmptyObject(dispositionNew.store || {})) {
        res = contentDisposition;
      } else {
        clearAllAndHardReload();
      }
    }
    return res;
  };

  return (
    <React.Fragment>
      <div id='startorder-container' data-testid='StartOrder-component' tabIndex='-1'>
        {showHeader && blackStripeContent()}
        {userOrderState.showLocationBlockBanner && displayNotifyMessage()}
        {userOrderState?.dispositionStateData?.showDisposition && <DispositionModule />}
        {!userOrderState?.findAKFC && userOrderState?.searchStoreData?.showSearchStore && (
          <LazyLoaderWrapper
            importPath={goToDeliveryAddressSearchForm ? 'DELIVERY_ADDRESS_SEARCH_FORM' : 'SEARCH_STORE_TEMPLATE'}
            deliverySearchType={deliverySearchType}
            setDeliverySearchType={setDeliverySearchType}
            onStoreSelectFinish={setLocalisationFinishAnalyticsData}
          />
        )}
        {userOrderState?.scheduleOrderData.showScheduleOrderCatering && (
          <LazyLoaderWrapper
            importPath='SCHEDULE_ORDER_TEMPLATE'
            onStoreSelectFinish={setLocalisationFinishAnalyticsData}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default StartOrderComponent;
